/**
 * Docs: one pile, two doors (#672 / #823 / #1025).
 * Series door: Timeline/Docs toggle → /projects/:id/notes
 * Book door: Book Planning Docs → /projects/:id/stories/:storyId/notes
 * Same Document Import v1 batches behind both. No sort at upload.
 * Offer or invoke — never silent-fill book notes or journeys.
 */

import {
  DOCS_EMPTY,
  DOCS_LEDE,
  DOCS_OFFER,
} from './writerCopy';

export const NOTES_LEDE = DOCS_LEDE;

export const NOTES_OFFER = DOCS_OFFER;

export const NOTES_EMPTY = DOCS_EMPTY;

/** Series Docs door. Timeline/Docs toggle. Not a book mode-switch. */
export function projectNotesPath(projectId) {
  return projectId ? `/projects/${projectId}/notes` : '/projects';
}

/** Book Planning Docs door. Same pile. Stays on the book map. */
export function bookNotesPath(projectId, storyId) {
  if (!projectId || !storyId) return projectNotesPath(projectId);
  return `/projects/${projectId}/stories/${storyId}/notes`;
}

/** From a book, stay in Book Planning Docs. Series door only when there is no book. */
export function notesPathForAltitude({ projectId, storyId } = {}) {
  if (projectId && storyId) return bookNotesPath(projectId, storyId);
  return projectNotesPath(projectId);
}

export function isProjectNotesPath(pathname) {
  return /^\/projects\/[^/]+\/notes\/?$/.test(pathname || '');
}

export function isBookNotesPath(pathname) {
  return /^\/projects\/[^/]+\/stories\/[^/]+\/notes\/?$/.test(pathname || '');
}

export function isProjectDocsOffersPath(pathname) {
  return /^\/projects\/[^/]+\/docs-offers\/?$/.test(pathname || '');
}

export function isBookDocsOffersPath(pathname) {
  return /^\/projects\/[^/]+\/stories\/[^/]+\/docs-offers\/?$/.test(pathname || '');
}

export function isDocsOffersPath(pathname) {
  return isProjectDocsOffersPath(pathname) || isBookDocsOffersPath(pathname);
}

export function isNotesPath(pathname) {
  return isProjectNotesPath(pathname)
    || isBookNotesPath(pathname)
    || isDocsOffersPath(pathname);
}

export function hasImportBatches(batches) {
  return Array.isArray(batches) && batches.length > 0;
}

export function emptyImportList() {
  return { batches: [] };
}
